var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ig-side-menu-bar" } },
    [
      _c(
        "router-link",
        {
          staticClass: "menu",
          class: { active: _vm.selectedPage === "integration" },
          attrs: { to: "/integrations/instagram" },
        },
        [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("chatbotv2.integration")) + "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "menu",
          class: { active: _vm.selectedPage === "users" },
          attrs: { to: "/integrations/instagram/users" },
        },
        [_vm._v("\n        " + _vm._s(_vm.$t("chatbotv2.Users")) + "\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }